export default class ProductsService {
  constructor(Api) {
    "ngInject"
    this.api = Api;

  }

  loadAllProducts() {
    return this.api.call({
      method: 'get',
      url: '/products'
    })
  }

  loadProductMaterials(productId) {
    return this.api.call({
      method: 'get',
      url: `/products/${productId}/materials`
    });
  }

  loadProductMaterialSpec(productId, materialId) {
    let
      url = `/products/${productId}/materials/${materialId}/spec`;
    return this.api.call({
      method: 'get',
      url
    });
  }

  loadProductMaterialPricing(productSlug, materialSlug) {
    let
      url = `/products/${productSlug}/materials/${materialSlug}/pricing_spec`;
    return this.api.call({
      method: 'get',
      url
    })
  }

  deleteProductMaterialShape(productId, materialId, shapeId) {
    let
      url = `/products/${productId}/materials/${materialId}/shapes/${shapeId}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }

  addProductMaterialShape(productId, materialId, shapeId) {
    let
      url = `/products/${productId}/materials/${materialId}/shapes/${shapeId}`;
    return this.api.call({
      method: 'post',
      url
    })
  }


  deleteProductMaterialFixmethod(productId, materialId, fixmethodId) {
    let
      url = `/products/${productId}/materials/${materialId}/fixmethods/${fixmethodId}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }

  addProductMaterialFixmethod(productId, materialId, fixmethodId) {
    let
      url = `/products/${productId}/materials/${materialId}/fixmethods/${fixmethodId}`;
    return this.api.call({
      method: 'post',
      url
    })
  }

  addProductMaterialColor(productId, materialId, colorId) {
    let
      url = `/products/${productId}/materials/${materialId}/colors/${colorId}`;
    return this.api.call({
      method: 'post',
      url
    })
  }

  deleteProductMaterialColor(productId, materialId, colorId) {
    let
      url = `/products/${productId}/materials/${materialId}/colors/${colorId}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }

  saveProductMaterialPricing(productSlug, materialSlug, spec) {
    let
      url = `/products/${productSlug}/materials/${materialSlug}/pricing_spec`;
    return this.api.call({
      method: 'post',
      url,
      data: spec,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  updateName(data, type) {
    let
      url = `/products/update_name/${type}`;
    return this.api.call({
      method: 'put',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }


}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/services/products.service.js
 **/